import eventHubFactory from '~/helpers/event_hub_factory';

export default eventHubFactory();
